import React from 'react';

/*
 *  @Description:   Stateless component that renders an Arrow.
 */

const Arrow = ( props ) => {

    return (
        <g id="path">
            <line x1="19" y1="12" x2="5" y2="12"/>
            <polyline points="12 19 5 12 12 5"/>
        </g>

    )

};

export default Arrow;

